module.exports = {"id":"228708","name":"Lucas Martínez Quarta","rating":"72","photo":"./data/images/photos/0/228708.png","club":{"name":"River Plate","logo":"./data/images/clubs/RiverPlate.png"},"positions":["DC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/LucasMartinezQuarta0.json
// module id = 2576
// module chunks = 0